export default __webpack_public_path__ + "static/media/earning.b019e86a.svg";